import 'UI/Widget/DataGridView';

/** @namespace Accounting.UI */
NS('Cadastre.UI');

/**
 * @class
 * @extends Accounting.UI.ObjectForm
 * @extends UI.Widget.Forms.Render.Light
 */
Cadastre.UI.Owners = Class(
	UI.Widget.DataGridView, {
		showFooter: false,
		sourceMethod: 'findDocuments',
		actions: [],
		columns: [
			{name: "part", title: "Доля собственности"},
			{name: "type.name", title: "Тип собственности"},
			{name: "date", title: "Дата"},
			{name: "entname", title: "Имя собственника"}
		],
		render: function () {
			this.ParentCall();
			this.reset();
			return this;
		}
	}
);